// src/modules/productos/composables/categoriaComposables/useCategoriasProductoList.ts
import { computed, Ref, watch } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import type { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import { ListCategoriasProductoAction } from "../../actions/categoriaActions";

export function useCategoriasProductoList(params: Ref<PaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // TanStack Query principal
  const query = useQuery({
    queryKey: ["CategoriaProductosList", params],
    queryFn: () => ListCategoriasProductoAction(params.value),
    staleTime: 60 * 1000,   // cache de 1 min
  });

  // Extraer datos en forma reactiva
  const categorias = computed(() => query.data.value?.data?.data?.categorias || []);
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(() => query.data.value?.data?.data?.totalPages || 0);
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // Prefetch cuando cambien los parámetros
  watch(params, (newParams) => {
    queryClient.prefetchQuery({
      queryKey: ["CategoriaProductosList", newParams],
      queryFn: () => ListCategoriasProductoAction(newParams),
    });
  }, { deep: true });

  return {
    ...query, 
    categorias,
    total,
    totalPages,
    currentPage,
  };
}
